// extracted by mini-css-extract-plugin
export var splash = "splash-module--splash--MSGU6";
export var splash__content = "splash-module--splash__content--mSdBt";
export var splash__firstLink = "splash-module--splash__firstLink--tCK0S";
export var splash__image = "splash-module--splash__image--XboGO";
export var splash__modal = "splash-module--splash__modal--esPOl";
export var splash__secondLink = "splash-module--splash__secondLink--FJD-f";
export var splash__text = "splash-module--splash__text--Agjsc";
export var splash__title = "splash-module--splash__title--uBjOt";